import { userApi } from '../../redux/services/userApi'
import './Form.scss'
import { FC, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import svg from "../../assets/img/sprite.svg";
import { IRegistrationUser } from '../../models/IRegistrationUser';
import { FormModalProps } from '../Header/Header';


export const RegistrationForm: FC<FormModalProps> = ({ setSuccessModal, setLogRegModal }) => {

  const [registrationUser, { isSuccess, isLoading, isError }] = userApi.useRegistrationUserMutation()

  const [onPass, setOnPass] = useState(false)

  const { register, handleSubmit, formState: { errors }, watch } = useForm({
    mode: 'onChange',
    defaultValues: {
      email: '',
      name: '',
      surname: '',
      password: '',
      password2: '',
    }
  })

  const password = watch('password')

  const onSubmit = async (data: IRegistrationUser) => {
    await registrationUser(data)

  }

/*   let test = false */

  useEffect(() => {
    if (isError) {
      alert('Ошибка входа. Такой пользователь уже существует');
    }
    else if (isSuccess) {
      setLogRegModal(false);
      setSuccessModal(true)
    }
  }, [isSuccess, isError, setLogRegModal, setSuccessModal]);

    return (
      <>
      <form className='form' onSubmit={handleSubmit(onSubmit)}>
      <div className='form__block'>
        <label className={errors.email ? "form__label error" : "form__label"}>
          <svg className="form__icon" width="22" height="19" fill="none">
            <use xlinkHref={`${svg}#email`}></use>
          </svg>
          <input className='form__input' type="email" placeholder="Электронная почта" {...register('email', {
            required: 'Поле не заполнено'
          })} />
        </label>
        <label className={errors.name ? "form__label error" : "form__label"}>
          <svg className="form__icon" width="24" height="25" fill="none">
            <use xlinkHref={`${svg}#user`}></use>
          </svg>
          <input className='form__input' type="text" placeholder="Имя" {...register('name', {
            required: 'Поле не заполнено'
          })} />
        </label>
        <label className={errors.surname ? "form__label error" : "form__label"}>
          <svg className="form__icon" width="24" height="25" fill="none">
            <use xlinkHref={`${svg}#user`}></use>
          </svg>
          <input className='form__input' type="text" placeholder="Фамилия" {...register('surname', {
            required: 'Поле не заполнено'
          })} />
        </label>
        <label className={errors.password ? "form__label error" : "form__label"}>
          <svg onClick={() => setOnPass(!onPass)} className={onPass ? "form__icon on form__icon_key" : "form__icon form__icon_key"} width="24" height="25" fill="none">
            <use xlinkHref={`${svg}#key`}></use>
          </svg>
          <input className='form__input' type={onPass ? "text" : "password"} placeholder="Пароль" {...register('password', {
            required: 'Поле не заполнено'
          })} />
        </label>
        <label className={errors.password2 ? "form__label error" : "form__label"}>
          <svg onClick={() => setOnPass(!onPass)} className={onPass ? "form__icon on form__icon_key" : "form__icon form__icon_key"} width="24" height="25" fill="none">
            <use xlinkHref={`${svg}#key`}></use>
          </svg>
          <input className='form__input' type={onPass ? "text" : "password"} placeholder="Подтвердите пароль" {...register('password2', {
            required: 'Поле не заполнено', validate: (value) => value === password
          })} />
        </label>
      </div>
      <button disabled={isLoading} className='form__btn btn btn-blue'>Создать аккаунт</button>
    </form >
    </>
    )
}